const MAX_PIXELS = 100_000_000;

const getResizedCanvas = (
  sourceImage,
  crop,
  scaling,
) => {
  const currentPixels = crop.height * scaling * crop.width * scaling;
  const aspect = crop.width / crop.height;

  const destinationPixels = Math.min(currentPixels, MAX_PIXELS);
  const destinationWidth = Math.floor(Math.sqrt(destinationPixels * aspect));
  const destinationHeight = Math.floor(destinationWidth / aspect);

  const temporaryCanvas = document.createElement('canvas');
  temporaryCanvas.width = destinationWidth;
  temporaryCanvas.height = destinationHeight;

  const context = temporaryCanvas.getContext('2d');
  context.imageSmoothingQuality = 'high';

  context.drawImage(
    sourceImage,
    crop.x * scaling,
    crop.y * scaling,
    crop.width * scaling,
    crop.height * scaling,
    0,
    0,
    destinationWidth,
    destinationHeight,
  );
  return temporaryCanvas;
};

const generateUpload = (
  sourceImage,
  crop,
  fileName,
  onSave,
  scaling,
  imageTitle,
  imageDescription,
  imageCredit,
  setDisabled,
  uploadOriginalFile,
) => {
  if (uploadOriginalFile) {
    return onSave(
      sourceImage,
      imageTitle,
      imageDescription,
      imageCredit,
      setDisabled,
    );
  }

  const canvas = getResizedCanvas(sourceImage, crop, scaling);

  const isPng = sourceImage.src.indexOf('image/png') === 5;
  const type = isPng ? 'image/png' : 'image/jpeg';
  const extension = isPng ? '.png' : '.jpg';

  return canvas.toBlob(
    (blob) => onSave(
      new File([blob], fileName.replace(/\.[^.]+$/, extension), {
        type,
      }),
      imageTitle,
      imageDescription,
      imageCredit,
      setDisabled,
    ),
    type,
    1,
  );
};

export const generateUploadWithValidation = (
  originalImage,
  completedCrop,
  fileName,
  onSave,
  uiScaling,
  imageCredit,
  imageTitle,
  imageDescription,
  setDisabled,
  uploadOriginalFile,
) => generateUpload(
  originalImage,
  completedCrop,
  fileName,
  onSave,
  uiScaling,
  imageCredit,
  imageTitle,
  imageDescription,
  setDisabled,
  uploadOriginalFile,
);

export default generateUploadWithValidation;
